import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Modal, Button } from "antd";
import { ExpandOutlined } from "@ant-design/icons";
/**
 * Modal that prompts the user to enter fullscreen mode before starting the meeting.
 * This is required because browsers only allow fullscreen requests after user interaction.
 */
const FullscreenEntryModal = ({ visible, onEnterFullscreen, primaryColor = "#1890ff", }) => {
    return (_jsxs(Modal, Object.assign({ open: visible, closable: false, footer: null, centered: true, maskClosable: false, width: 480, styles: {
            body: {
                padding: "32px 24px",
                textAlign: "center",
            },
        } }, { children: [_jsx(ExpandOutlined, { style: {
                    fontSize: 48,
                    color: primaryColor,
                    marginBottom: 24,
                } }), _jsx("h2", Object.assign({ style: { marginBottom: 16, fontSize: 20, fontWeight: 600 } }, { children: "Enter Fullscreen Mode" })), _jsx("p", Object.assign({ style: { marginBottom: 8, color: "#666", fontSize: 14 } }, { children: "This interview requires fullscreen mode for proctoring purposes." })), _jsx("p", Object.assign({ style: { marginBottom: 24, color: "#666", fontSize: 14 } }, { children: "Please click the button below to enter fullscreen and start your interview." })), _jsx(Button, Object.assign({ type: "primary", size: "large", icon: _jsx(ExpandOutlined, {}), onClick: onEnterFullscreen, style: {
                    backgroundColor: primaryColor,
                    borderColor: primaryColor,
                    height: 48,
                    paddingInline: 32,
                    fontSize: 16,
                } }, { children: "Enter Fullscreen & Start Interview" })), _jsx("p", Object.assign({ style: { marginTop: 16, color: "#999", fontSize: 12 } }, { children: "Note: Exiting fullscreen mode during the interview may result in warnings." }))] })));
};
export default FullscreenEntryModal;
